import { Pipe, PipeTransform } from '@angular/core';
import { UserProfile } from '../models/user-profile.model';
import { Roles } from '../enums/roles.enum';
import { EmployeeService } from '../services';

@Pipe({name: 'userDisplayName'})
export class UserDisplayNamePipe implements PipeTransform {

  transform(value: UserProfile) {
      if (!value) return '';
      return value.employee ? value.employee.name : value.email;
  }
}

@Pipe({name: 'roleDisplayName'})
export class RoleDisplayNamePipe implements PipeTransform {

  constructor(private employeeService: EmployeeService) {
  
  }

  transform(value: Roles) {
      if (!value) return '';
      
      return this.employeeService.getRoleDisplayName(value);
  }
}
